/*
  QUIVER - referral links (Frame Your Wave photographers).

  A photographer's link is any QUIVER page with ?ref=their-code. When a
  shopper arrives on one, the code is kept in this browser for 60 days and
  written onto their basket as the attribute "Referred by", so it appears on
  the order in Shopify admin (and in order exports) with no app involved.
  A later visit with a different ?ref= replaces the earlier one.
*/
(function () {
  var KEY = 'quiver-ref';
  var DAYS = 60;
  var code = null;
  try {
    var q = new URLSearchParams(window.location.search).get('ref');
    if (q) {
      code = String(q).toLowerCase().replace(/[^a-z0-9-]/g, '').slice(0, 60);
      if (code) localStorage.setItem(KEY, JSON.stringify({ code: code, until: Date.now() + DAYS * 864e5 }));
    }
  } catch (e) {}
  if (!code) {
    try {
      var saved = JSON.parse(localStorage.getItem(KEY) || 'null');
      if (saved && saved.until > Date.now() && saved.code) code = saved.code;
      else if (saved) localStorage.removeItem(KEY);
    } catch (e) {}
  }
  if (!code) return;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  function tag() {
    fetch(root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var a = (cart && cart.attributes) || {};
        if (a['Referred by'] === code) return;
        return fetch(root + 'cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: { 'Referred by': code } }),
        });
      })
      .catch(function () {});
  }
  tag();
  // The Frame Your Wave form adds to the basket with a full page post; the
  // attribute set above survives that. Re-tag after any script-based add too.
  document.addEventListener('submit', function (e) {
    if (e.target && e.target.action && /\/cart\/add/.test(e.target.action)) {
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'attributes[Referred by]';
      input.value = code;
      e.target.appendChild(input);
    }
  }, true);
})();
